
import { Vue, Component, Prop } from "vue-property-decorator";
import SectionHeader from "./components/SectionHeader.vue";
import InfoField from "./components/InfoField.vue";
import InfoSection from "./components/InfoSection.vue";

@Component({
  components: {
    SectionHeader,
    InfoField,
    InfoSection,
  },
})
export default class HomeEnvironment extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: object;

  get hasPets(): boolean {
    return (
      this.data.pets &&
      Array.isArray(this.data.pets) &&
      this.data.pets.length > 0
    );
  }

  get formattedPets(): string[] {
    if (!this.hasPets) return [];

    if (typeof this.data.pets === "string") {
      return this.data.pets.split(",").map((pet) => pet.trim());
    }

    return this.data.pets;
  }
}
